import { Injectable, computed } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  currentLocale = computed(() => {
    const locale = this.dataService.locale();
    setTimeout(() => {
      this.setLocale(locale);
    }, 100);
  });
  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
  ) {}

  setLocale(locale: string) {
    this.translateService.setDefaultLang(locale);
    this.translateService.use(locale);
  }

  initializeLocale() {
    this.currentLocale();
  }
}
